<template>
  <div>
    <div
      v-if="!open"
      @click="openSidebar"
    >
      <div class="line" />
      <div class="line" />
      <div class="line" />
    </div>
    <transition
      name="sidebar"
      enter-active-class="animated slideInLeft"
      leave-active-class="animated slideOutLeft"
    >
      <TheSidebar
        v-if="open"
        mobile
        @close="open = false"
      />
    </transition>
  </div>
</template>

<script>
import TheSidebar from './TheSidebar.vue'

export default {
  name: 'SidebarMobile',

  components: {
    TheSidebar,
  },

  data() {
    return {
      open: false,
    }
  },

  methods: {
    openSidebar() {
      this.open = true
      this.$emit('open')
    },
  },
}
</script>

<style lang="postcss" scoped>
.line {
  @apply border-b-4 border-blue w-8 mt-1;
}
</style>
